/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Change, ChangeOptions, ObservableModel } from '@typescript-kit/core';
import { LetterHeaderModel } from '@teamworks/global';

export interface LetterHeaderViewData {
  letterHeader?: LetterHeaderModel;
}

export class LetterHeaderViewKey {
  static readonly LETTER_HEADER = 'letterHeader';
}

export class LetterHeaderViewModel extends ObservableModel implements LetterHeaderViewData {
  static readonly KEYS = Object.keys(LetterHeaderViewKey).map((key) => LetterHeaderViewKey[key]);

  constructor(values: LetterHeaderViewData) {
    super(values, LetterHeaderViewModel.KEYS);
  }

  get letterHeader(): LetterHeaderModel {
    return this.get(LetterHeaderViewKey.LETTER_HEADER);
  }

  set letterHeader(value: LetterHeaderModel) {
    this.set(LetterHeaderViewKey.LETTER_HEADER, value);
  }

  setValues(values: LetterHeaderViewData, options?: ChangeOptions): { [p: string]: Change<any> } {
    return super.setValues(values, options);
  }
}

